import { useLocation } from "react-router-dom";

export const DEFAULT_EXAMINEE_SIGN_IN_NEXT_NAME = "next";
export const DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH =
  "/examinee/primary_interview_introduction";

/**
 * クエリパラメータからnextのパスを取得します。
 * next パラメータが存在しない場合、{@link DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH デフォルトのパス}を返却します。
 * @param defaultPath デフォルトのパス
 * @returns next のパス
 */
export function useExamineeSignInNextPath(
  defaultPath = DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH
) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const nextPath = query.get(DEFAULT_EXAMINEE_SIGN_IN_NEXT_NAME) ?? defaultPath;
  return nextPath;
}
